/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Radio } from 'antd';

import { Form } from '@organisms';

const RadioField = ({ options = [], radioStyle, disabled, ...props }) => {
  return (
    <Form.Item {...props}>
      <Radio.Group>
        {options.map((option, index) => (
          <Radio style={radioStyle} key={index} disabled={disabled} value={option.value}>
            {option.label}
          </Radio>
        ))}
      </Radio.Group>
    </Form.Item>
  );
};

export default RadioField;
